<template>
  <div>
    <v-dialog persistent v-model="itemDialog" max-width="500">
      <v-card
        v-if="
          coverageTileItemCoverageTile !== null &&
            coverageTileItemCoverageTile !== undefined
        "
      >
        <v-card-title>
          {{ $t("components.portalcoverage.categoryedit.set_order") }}
        </v-card-title>
        <v-card-text>
          <v-form v-model="itemValid">
            <no-autocomplete-textfield
              type="number"
              :label="$t('globals.priority')"
              v-model="coverageTileItemCoverageTile.Order"
              :rules="[$rules.requiredNum]"
            />
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-btn text @click="closeItemDialog()">
            {{ $t("globals.cancel") }}
          </v-btn>
          <v-btn :disabled="!itemValid" color="primary" @click="saveItem()">
            {{ $t("globals.save") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      scrollable
      persistent
      :value="itemInternal !== null"
      max-width="800"
    >
      <material-card
        :title="$t('components.portalcoverage.categoryedit.coverage_items')"
        :color="$vuetify.theme.themes.light.primary"
        icon="edit"
        v-if="itemInternal !== undefined && itemInternal !== null"
      >
        <v-card-text>
          <v-form :disabled="loading" ref="form" v-model="valid">
            <v-container>
              <div class="row">
                <div class="col-12 col-md-6">
                  <trans-textbox
                    label="Name"
                    v-model="itemInternal"
                    :rules="[$rules.required]"
                    field="Name"
                    class="required"
                  />
                </div>
                <div class="col-12 col-xs-12">
                  <trans-texteditor
                    v-model="itemInternal"
                    :label="$t('headers.coverageitems.html')"
                    field="Html"
                  ></trans-texteditor>
                </div>
              </div>
              <!-- <div class="col-12 col-xs-12">
                <h3>{{$t('Coverage Categories')}}</h3>
                <DualListBoxSingleSelect
                  :source="categories"
                  :destination="itemInternal.CoverageTileItemCoverageTiles"
                  :displayFunc1="(item) => `${translate2(item, 'Name')}`"
                  :displayFunc2="
                    (item) => `${translate2(item.CoverageTile, 'Name')}`
                  "
                  @add-destination="onAddItem"
                  @add-source="onRemoveItem"
                >
                </DualListBoxSingleSelect>
              </div> -->
              <div class="col-12 align-self-center">
                <trans-select2
                  v-model="itemInternal"
                  propertyName="Category"
                  :items="categories"
                  :label="$t('headers.coverageitems.category')"
                  field="Name"
                  itemValue="Id"
                ></trans-select2>
              </div>
              <div class="col-md-6 col-xs-12">
                <v-checkbox
                  :label="$t('headers.downloadcategories.allow_guests')"
                  v-model="itemInternal.AllowedGuest"
                ></v-checkbox>
              </div>
              <div class="col-12 align-self-center" v-if="classes.length > 0">
                <auto-select
                  clear-icon="clear"
                  :clearable="true"
                  :label="$t('headers.members_management.Class')"
                  :value.sync="selectedClass"
                  :items="classes"
                ></auto-select>
              </div>
            </v-container>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-btn
            text
            :disabled="loading"
            @click="
              itemInternal = null;
              $emit('cancel');
            "
          >
            {{ $t("globals.cancel") }}
          </v-btn>
          <v-btn
            color="primary"
            :loading="loading"
            @click="save()"
            :disabled="!valid"
          >
            {{ $t("globals.save") }}
          </v-btn>
        </v-card-actions>
        <error-handler :error="error"></error-handler>
      </material-card>
    </v-dialog>
  </div>
</template>

<script>
import deepClone from "../../utils/deepClone";
import { mapActions, mapGetters } from "vuex";
import ErrorHandler from "../../components/ErrorHandler";
import TransTextbox from "../../components/TransTextbox";
import TransTexteditor from "../../components/TransTexteditor";
import DualListBoxSingleSelect from "../DualListboxSingleSelect";
import { translate2 } from "../../trans2";
import AutoSelect from "../../components/AutoSelect";
import TransSelect2 from "../TransSelect2.vue";
import NoAutocompleteTextfield from "../../components/NoAutocompleteTextfield";

export default {
  components: {
    ErrorHandler,
    TransTextbox,
    TransTexteditor,
    DualListBoxSingleSelect,
    AutoSelect,
    TransSelect2,
    NoAutocompleteTextfield,
  },
  props: {
    item: Object,
    allCategories: Array,
  },
  data: () => ({
    selectedClass: null,
    classes: [],
    valid: false,
    itemInternal: null,
    loading: false,
    error: null,
    categories: [],
    coverageTileItemCoverageTile: undefined,
    itemDialog: false,
    itemValid: false,
  }),
  computed: {
    ...mapGetters("common", { selectedPlan: "plan" }),
  },
  watch: {
    item: {
      handler(val) {
        this.itemInternal = deepClone(this.item);
        if (this.itemInternal && this.itemInternal.ClassCoverageTileItem) {
          this.selectedClass = this.itemInternal.ClassCoverageTileItem.Class;
        } else {
          this.selectedClass = null;
        }
        if (
          this.itemInternal &&
          this.itemInternal.CoverageTileItemCoverageTiles &&
          this.itemInternal.CoverageTileItemCoverageTiles.length > 0
        ) {
          this.itemInternal.Category = this.itemInternal.CoverageTileItemCoverageTiles[0].CoverageTile;
        }
        this.reset();
      },
      immediate: true,
    },
    allCategories: {
      handler(v) {
        this.categories = [].concat(this.allCategories);
        this.reset();
      },
    },
  },
  methods: {
    ...mapActions("downloadCenter", ["saveCoverageTileItem"]),
    ...mapActions("plansMembers", ["getCoverageIdentities", "getPlan"]),
    translate2(item, field) {
      return translate2(item, field);
    },
    // saveItem() {
    //   this.itemInternal.CoverageTileItemCoverageTiles.push(
    //     JSON.parse(JSON.stringify(this.coverageTileItemCoverageTile))
    //   );
    //   this.categories.splice(
    //     this.categories.indexOf(this.coverageTileItemCoverageTile.CoverageTile),
    //     1
    //   );
    //   this.itemDialog = false;
    //   this.coverageTileItemCoverageTile = undefined;
    // },
    // closeItemDialog() {
    //   this.itemDialog = false;
    //   this.coverageTileItemCoverageTile = undefined;
    // },
    // onAddItem({ selected }) {
    //   this.coverageTileItemCoverageTile = {
    //     CoverageTile: selected[0],
    //     Order: 0,
    //   };
    //   this.itemDialog = true;
    // },
    // onRemoveItem({ selected }) {
    //   this.categories.push(selected[0].CoverageTile);
    //   this.itemInternal.CoverageTileItemCoverageTiles.splice(
    //     this.itemInternal.CoverageTileItemCoverageTiles.indexOf(selected[0]),
    //     1
    //   );
    // },
    async save() {
      try {
        let item = JSON.parse(JSON.stringify(this.itemInternal));
        if (item.Category !== null && item.Category !== undefined) {
          item.CoverageTileItemCoverageTiles = [
            {
              CoverageTileId: item.Category.Id,
              Order: 0,
            },
          ];
          delete item.Category;
        }
        // for (let row of item.CoverageTileItemCoverageTiles) {
        //   row.CoverageTileId = row.CoverageTile.Id;
        //   delete row.CoverageTile;
        //   delete row.selected;
        // }
        if (this.selectedClass && this.selectedClass.length > 0) {
          item.ClassCoverageTileItem = {
            Class: this.selectedClass,
            PlanId: this.selectedPlan.Id,
          };
        }

        await this.withLoad(this.saveCoverageTileItem(item));
        this.$emit("update:item", this.itemInternal);
        this.$emit("reload-categories");
      } catch (e) {
        this.error = e;
      }
    },
    async withLoad(promise) {
      this.error = null;
      this.loading = true;
      try {
        await promise;
      } finally {
        this.loading = false;
      }
    },
    async reset() {
      this.allCoverage = (await this.getCoverageIdentities({
        plan: this.selectedPlan.Id,
      })).value;
      if (this.itemInternal) {
        let itemCoverage = JSON.parse(this.itemInternal.JsonCoverageIds);
        if (itemCoverage) {
          this.coverage = this.allCoverage.filter(
            (o) => itemCoverage.filter((c) => c === o.Id).length === 0
          );
          this.itemCoverage = this.allCoverage.filter(
            (o) => itemCoverage.filter((c) => c === o.Id).length > 0
          );
        } else {
          this.coverage = [].concat(this.allCoverage);
          this.itemCoverage = [];
        }
        // if (this.itemInternal.CoverageTileItemCoverageTiles) {
        //   this.categories = this.allCategories.filter(
        //   (o) =>
        //     this.itemInternal.CoverageTileItemCoverageTiles.filter(
        //       (c) => c.CoverageTile.Id === o.Id
        //     ).length === 0
        // );
        // } else {
        // this.categories = [].concat(this.allCategories);
        // }
      }
    },
  },
  async mounted() {
    try {
      const plan = (await this.getPlan(this.selectedPlan.Id)).data;
      this.classes =
        plan && plan.Current.Classes
          ? JSON.parse(plan.Current.Classes).sort((a, b) => {
              return a.localeCompare(b);
            })
          : [];
    } catch (error) {
      this.error = error;
    }
  },
};
</script>
